import React, { memo } from 'react';
import { ActionBar, Button, Link } from '@beef/ui-kit';
export var ModalActionBar = /*#__PURE__*/memo(function (_ref) {
  var _button$size, _button$variant, _button$size2, _button$variant2, _buttonReject$size, _buttonReject$variant;
  var button = _ref.button,
    buttonReject = _ref.buttonReject,
    onConfirm = _ref.onConfirm,
    onReject = _ref.onReject;
  return /*#__PURE__*/React.createElement(ActionBar, {
    size: "s"
  }, (button === null || button === void 0 ? void 0 : button.text) && (button === null || button === void 0 ? void 0 : button.url) && /*#__PURE__*/React.createElement(Link, {
    buttonSize: (_button$size = button === null || button === void 0 ? void 0 : button.size) !== null && _button$size !== void 0 ? _button$size : 'm',
    buttonVariant: (_button$variant = button === null || button === void 0 ? void 0 : button.variant) !== null && _button$variant !== void 0 ? _button$variant : 'tertiary',
    href: button.url,
    size: "size5-m",
    variant: "button"
  }, button.text), !(button !== null && button !== void 0 && button.url) && onConfirm && /*#__PURE__*/React.createElement(Button, {
    onClick: onConfirm,
    size: (_button$size2 = button === null || button === void 0 ? void 0 : button.size) !== null && _button$size2 !== void 0 ? _button$size2 : 'm',
    variant: (_button$variant2 = button === null || button === void 0 ? void 0 : button.variant) !== null && _button$variant2 !== void 0 ? _button$variant2 : 'tertiary'
  }, button === null || button === void 0 ? void 0 : button.text), !!buttonReject && onReject && /*#__PURE__*/React.createElement(Button, {
    onClick: onReject,
    size: (_buttonReject$size = buttonReject === null || buttonReject === void 0 ? void 0 : buttonReject.size) !== null && _buttonReject$size !== void 0 ? _buttonReject$size : 'm',
    variant: (_buttonReject$variant = buttonReject === null || buttonReject === void 0 ? void 0 : buttonReject.variant) !== null && _buttonReject$variant !== void 0 ? _buttonReject$variant : 'tertiary'
  }, buttonReject.text));
});